import type { Invoice } from "@/graphql/codegen/graphql"

export type InvoiceAs400SyncStatusField =
  | "as400ApproveSyncStatus"
  | "as400PaidSyncStatus"
  | "as400VoidSyncStatus"
  | "as400ReversalSyncStatus"

export type InvoiceAs400SyncState = Pick<Invoice, "status" | InvoiceAs400SyncStatusField>

export enum InvoiceAs400SyncIndicatorVariant {
  Pending = "pending",
  Failed = "failed",
  Resolved = "resolved",
}

export interface InvoiceAs400SyncIndicatorConfig {
  variant: InvoiceAs400SyncIndicatorVariant
  tooltip: string
}
